export const numberAssignedPatientsVisitor = (numberAssignedPatients: number) => <ACCEPT>(variant: {
   visitNoAssignedPatients: (numberAssignedPatients: number) => ACCEPT;
   visitAssignedPatients: (numberAssignedPatients: number) => ACCEPT;
}) => {
   if (numberAssignedPatients === 0) {
      return variant.visitNoAssignedPatients(numberAssignedPatients);
   }

   return variant.visitAssignedPatients(numberAssignedPatients);
};
